export type SinglePermission = {
	type: 'A' | 'D' | 'B';
	accountId: string;
	accountName?: string;
	departmentId?: string;
	billingAccountId?: string;
	departmentName?: string;
	departmentUiColor?: string;
	permissionExpiration?: string;
};

const model: types.models.InputModel = {
	type: 'permissionType',
	accountId: 'accountId',
	accountName: 'accountName',
	departmentId: 'departmentId',
	billingAccountId: 'billingAccountId',
	departmentName: 'departmentName',
	departmentUiColor: 'departmentUiColor',
	permissionExpiration: 'permissionExpiration',
};

export default model;
